import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      axios
        .get(`${config.REACT_APP_API_URL}/user-profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY
          },
        })
        .then(() => {
          setIsAuthenticated(true);
        })
        .catch(() => {
          localStorage.removeItem('accessToken');
          setIsAuthenticated(false);
        });
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  if (isAuthenticated === null) {
    return <div className="text-center py-4">Chargement...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login-register" replace />;
};

export default ProtectedRoute;